import { EndPoints } from '../EndPoints';
import {
    QuestionDataForm,
    QuestionFile,
    QuestionFilters
} from '../../models/Question';
import useFetch from '../../../hooks/useFetch';
import { useState, useContext } from 'react';
import { ServiceEvents } from '../shared/interfaces';
import { AppContext } from '../../../contexts/AppContext';

const useQuestionFileService = () => {
    const { showLoading, hideLoading, changeAnimation } = useContext(AppContext);
    const { doGet, doPost, doPut, doDelete } = useFetch();


    const [fetchingStoreQuestionFile, setFetchingStoreQuestionFile] =
        useState(false);
    const [fetchingUpdateQuestionFile, setFetchingUpdateQuestionFile] =
        useState(false);


    const storeQuestionFile = (
        questionFile: QuestionFile,
        events: ServiceEvents = {}
    ) => {
        doPost({
            ...events,
            url: EndPoints.QUESTION_FILES.STORE_QUESTION_FILE,
            body: questionFile,
            requestType: 'multipart',
            setFetching: setFetchingStoreQuestionFile
        });
    };

    const updateQuestionFile = (
        id: number,
        questionFile: QuestionFile,
        events: ServiceEvents = {}
    ) => {
        doPut({
            ...events,
            url: EndPoints.QUESTION_FILES.UPDATE_QUESTION_FILE.replace(':id', id.toString()),
            body: questionFile,
            requestType: 'multipart',
            setFetching: setFetchingUpdateQuestionFile
        });
    };

    return {
        storeQuestionFile,
        updateQuestionFile,
        fetchingStoreQuestionFile,
        fetchingUpdateQuestionFile
    };
};

export default useQuestionFileService;
